import React from 'react';
import { FilterContent, SearchWrapper } from './filter-feedback-subject.styles';
import { Checkbox } from '@vtbhome/juicyfront';
import { FilterFeedbackSubjectsProps } from './types';
import { DEFAULT_FEEDBACK_SUBJECTS_LIST_PARAMETERS } from '@entities/feedback-subject/config/store-constants';
import { Search } from '@shared/ui/search/search';
import { Filter } from '@shared/ui/filter/filter';

export const FilterFeedbackSubjects: React.FC<FilterFeedbackSubjectsProps> = ({
    children,
    feedbackSubjectsListParameters,
    setFeedbackSubjectsListParameters,
}) => {
    return (
        <SearchWrapper>
            <Search
                parameters={feedbackSubjectsListParameters}
                placeholder='Поиск'
                setParameters={setFeedbackSubjectsListParameters}
            />
            <Filter
                onResetAllFilters={() => setFeedbackSubjectsListParameters(DEFAULT_FEEDBACK_SUBJECTS_LIST_PARAMETERS)}>
                <FilterContent>
                    <Checkbox
                        label='Отображать только активные'
                        checked={Boolean(feedbackSubjectsListParameters.active)}
                        onChange={(e) =>
                            setFeedbackSubjectsListParameters((prev) => ({
                                ...prev,
                                active: e.target.checked || null,
                            }))
                        }
                    />
                </FilterContent>
            </Filter>
            {children}
        </SearchWrapper>
    );
};
